import * as React from "react";
const SvgPaperclip = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.5232 9.36999L10.5895 15.3037C8.96232 16.9308 6.32413 16.9308 4.69695 15.3037C3.06977 13.6765 3.06977 11.0383 4.69695 9.4111L10.3931 3.71496C11.4779 2.63017 13.2367 2.63017 14.3215 3.71496C15.4062 4.79975 15.4062 6.55854 14.3215 7.64333L8.63446 13.3303C8.09206 13.8727 7.21267 13.8727 6.67027 13.3303C6.12788 12.7879 6.12788 11.9085 6.67027 11.3661L11.8548 6.18161",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgPaperclip;
